import React from 'react'
import * as R from 'remeda'

import { useSurveyQueryCustomerAttributeGroups } from './useSurveyQueryCustomerAttributeGroups'

export const useSurveyQueryFlattenCustomerAttributes = () => {
  const customerAttributeGroups = useSurveyQueryCustomerAttributeGroups()

  return React.useMemo(
    () => customerAttributeGroups.flatMap(R.prop('customerAttributes')),
    [customerAttributeGroups],
  )
}
